module.exports = __webpack_public_path__ + "static/media/payment-process.21ff95ba.svg";